<template>
  <div class="solution2">
    <!--1:banner-->
    <div class="block s2_banner">
      <div :class="{content:true}">
        <div class="item1">
          <div class="box">
            <p :class="{title:true,animated:true,fadeInUp:isUp,delay2s:true}">网站全时安全管控平台</p>
            <div :class="{detail:true,animated:true,fadeInUp:isUp,delay3s:true}">
              可定制化的网站管控系统；从安全监测、漏洞巡查、实时告警、及时响应、秒级封禁等几个环节，全方位保障网站安全可用性。
            </div>
            <a :class="{btn:true,animated:true,fadeInUp:isUp,delay4s:true}" @click="goU('startApply')">联系我们</a>
          </div>
        </div>
      </div>
    </div>
    <!--2:一站式安全服务-->
    <div class="s2_block2" id="s2_animateBox1">
      <p class="title">一站式安全服务</p>
      <div class="wrap">
        <div class="block wrap_box">
          <div class="solution2_topBox">
            <!--上部分-->
            <div class="flex_space s2_topBoxinfo">
              <div>
                <p class="topTitle"><span>01</span>事前检测</p>
                <div class="topMid"><span>安全评估</span>漏洞扫描 渗透测试 架构分析 安全咨询</div>
                <div class="topMid"><span>解决建议</span>协助加固</div>
              </div>
              <div>
                <p class="topTitle"><span>02</span>事中监测</p>
                <div class="topMid"><span>监控预警</span>网站可用性 主机监控 web漏洞 网页篡改</div>
                <div class="topMid"><span>安全通告</span>微信通知 短信告警 邮件通知 语音通知</div>
              </div>
              <div>
                <p class="topTitle"><span>03</span>事后响应</p>
                <div class="topMid"><span>应急响应</span>应急恢复 关联分析 事件规避 秒封秒解 </div>
                <div class="topMid">专家服务</div>
              </div>
            </div>
            <!--下部分-->
            <div class="s2_bottomBoxinfo flex_center"><i></i></div>
          </div>
          <div class="w_bot">
            <ul :class="{ul_box:true, flex_between:true,}">
              <li>
                <p :class="{mid:true,animated:true,fadeIn:isUp1,displayNone:isDisplay1}">安全检测</p>
                <div :class="{detail:true,animated:true,fadeIn:isUp1,delay1s:true,displayNone:isDisplay1}">
                  自动发现网站或服务器暴露在网络中的安全风险，为云上业务提供多维度的安全检测服务，满足合规要求，让安全弱点无所遁形。
                </div>
              </li>
              <li>
                <p :class="{mid:true,animated:true,fadeIn:isUp1,displayNone:isDisplay1}">多云监控</p>
                <div :class="{detail:true,animated:true,fadeIn:isUp1,delay1s:true,displayNone:isDisplay1}">
                  集中管理用户在混合云环境下的多种资源，远程一键操作云主机开机、关机和重启，查询云主机详情，监控云主机资源等操作。兼容性高，管理成本低，统一技术支持服务，减少技术服务沟通成本。
                </div>
              </li>
              <li>
                <p :class="{mid:true,animated:true,fadeIn:isUp1,displayNone:isDisplay1}">多维度告警</p>
                <div :class="{detail:true,animated:true,fadeIn:isUp1,delay1s:true,displayNone:isDisplay1}">
                  实施多维度全方位的告警通知体系，进行点到点，点到面的通知机制，以短信、邮箱、语音、钉钉多种方式告警通知，不断推进政务网站安全预警建设；做到全域覆盖、全时可用、全程可控的多项标准。
                </div>
              </li>
            </ul>
            <ul :class="{ul_box:true, flex_between:true,}">
              <li>
                <p :class="{mid:true,animated:true,fadeIn:isUp1,delay2s:true,displayNone:isDisplay1}">秒封秒解</p>
                <div :class="{detail:true,animated:true,fadeIn:isUp1,delay3s:true,displayNone:isDisplay1}">
                  牛盾网络独创“秒封秒解”技术，通过分析流量数据包，实时检测安全威胁，封禁相关问题端口和URL，将安全问题网站及时封停，待问题解决后及时解封，最大限度地降低危害和不良影响。
                </div>
              </li>
              <!--<li :class="{flexCol_aroud:true,animated:true,fadeInUp:isUp1,displayNone:isDisplay1,delay6s: true}">-->
              <li>
                <p :class="{mid:true,animated:true,fadeIn:isUp1,delay2s:true,displayNone:isDisplay1}">可视化大屏</p>
                <div :class="{detail:true,animated:true,fadeIn:isUp1,delay3s:true,displayNone:isDisplay1}">
                  链接多种数据源，卡片式页面布局，图表和可视化图形展示，实时动态对网站进行监控和告警，提供透明化的数据分析和决策能力，让网站安全一目了然。
                </div>
              </li>
              <!--<li :class="{flexCol_aroud:true,animated:true,fadeInUp:isUp1,displayNone:isDisplay1,delay7s: true}">-->
              <li>
                <p :class="{mid:true,animated:true,fadeIn:isUp1,delay2s:true,displayNone:isDisplay1}">手机一键管理</p>
                <div :class="{detail:true,animated:true,fadeIn:isUp1,delay3s:true,displayNone:isDisplay1}">
                  支持手机移动端可以快速直观概览所有网站总概况、漏洞扫描详情等功能。同时，还提供一键封禁开启网站操作，方便用户随时随地管理网站。
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--4:应用场景-->
    <div :class="{block:true, s2_apply:true}" id="s2_animateBox2">
      <p :class="{title:true}">应用场景</p>
      <div class="content">
        <ul class="ul_apply flex_around">
          <!--<li :class="{animated:true,fadeInUp:isUp2,displayNone:isDisplay2,}">-->
          <li>
            <div class="img_wrap img1">
              <h4 class="describe">互联网企业</h4>
            </div>
            <p class="txt">对网站资源进行安全管理和监控，定时安全检测，及时发现网站漏洞，告警并及时响应。</p>
          </li>
          <!--<li :class="{animated:true,fadeInUp:isUp2,displayNone:isDisplay2,delay1s: true}">-->
          <li>
            <div class="img_wrap img2">
              <h4 class="describe">监管机构</h4>
            </div>
            <p class="txt">帮助监管部门监测网站直观展示监测结果，发现风险第一时间告警，镜像阻断，秒级生效。</p>
          </li>
          <!--<li :class="{animated:true,fadeInUp:isUp2,displayNone:isDisplay2,delay2s: true}">-->
          <li>
            <div class="img_wrap img3">
              <h4 class="describe">政府机构</h4>
            </div>
            <p class="txt">基于政府单位等关键领域公共信息系统，迅速识别网页异常并通知告警，避免影响政府单位形象。</p>
          </li>

        </ul>
      </div>
    </div>
    <!--5:客户案例-->
    <div class="block s2_clientCase">
      <p class="title">客户案例</p>
      <div class="content">
        <div class="icon_wrap">
          <!-- <span class="tz">台州大数据中心</span>-->
          <i class="icon icon_taizhou"></i>
        </div>
        <el-tabs v-model="activeName" class="tab_client">
          <el-tab-pane label="业务痛点" name="first">
            <p class="tab_txt">
              2017年国家颁布并实施了《网络安全法》，保障网络安全、稳定运行，有效应对网络安全事件，防范网络违法犯罪活动等都是国家政策的重要体现；台州大数据中心承载着多种社会公众网站，极有可能成为国内外诸多不法分子的攻击目标，人工安全检测效率低下，响应速度慢，遇到事故无法及时止损，因此如何做好网站的安全管控显得尤为重要。</p>
          </el-tab-pane>
          <el-tab-pane label="解决方案" name="second">
            <p class="tab_txt">
              先黑客一步发现问题：通过模拟真实的黑客攻击手段，从海量蜜罐系统中提取数据，筛选出无数可穿墙的程序代码，最后再编译到牛盾漏洞扫描规则库中，真正做到先黑客一步发现问题，助力政府、企业和个人打造安全、稳定、高效的业务应用环境。秒封秒解：牛盾网络独创“秒封秒解”技术，通过分析流量数据包，实时检测安全威胁，封禁相关问题端口和URL，将安全问题网站及时封停，待问题解决后及时解封，最大限度地降低危害和不良影响。</p>
          </el-tab-pane>
          <el-tab-pane label="方案价值" name="third">
            <p class="tab_txt">
              多向性安全防护能力、旁路网站防护能力、网络数据安全审计能力，全方位保障网站安全可用性，做到事前风险自检、事中快速响应、事后及时解决，全面解决云平台面临的威胁。为台州大数据中心提供更专业和高效的网站管控服务，提高工作效率，提升网站服务能力，响应数字智慧化办公的建设思想，促进数字化办公的发展。</p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--6:联系我们-->
    <div class="block s2_contactUs">
      <canvas id="canvas3" style="width:100%;height:210px;"></canvas>
      <div class="contact flexCol_aroud">
        <p>马上使用网站全时安全管控解决方案</p>
        <!--<p class="txt">致力于更高效的网站管理，更全面的安全保障，更及时的应急响应</p>-->
        <div class="button_contact" @click="goU('startApply')">联系我们</div>
      </div>
    </div>
    <!--foot-->
    <div class="foot">
      <footBar></footBar>
    </div>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import footBar from '../../components/footerbar'
  import returnTop from '../../components/returnTop'
  import Case from '../../components/case'
  import {getCanvas} from '../../api/common'

  export default {
    name: "product2",
    data() {
      return {
        activeName: 'first',
        swiperOption: {
          autoplay: true,
          speed: 500,
          loop: true,
          type: 'custom',
          navigation: {
            nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          },
          pagination: {
            el: '.pag',
            bulletElement: "li",

          }
        },
        isUp: false,
        isUp1: false,
        isUp2: false,
        isUp3: false,
        isDisplay1: true,
        isDisplay2: true,
        isDisplay3: true,
      }
    },
    components: {
      footBar, Case, returnTop
    },
    mounted() {
      getCanvas('canvas3');
      this.isUp = true;
      window.addEventListener('scroll', this.scrollFun);
    },
    methods: {
      scrollFun() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//窗口滚动条滚动高度
        let animateBox1 = document.getElementById('s2_animateBox1');
        let animateBox2 = document.getElementById('s2_animateBox2');
        // let animateBox3 = document.getElementById('s2_animateBox3');
        let scrollDiv1 = animateBox1.offsetTop - scrollTop;
        let scrollDiv2 = animateBox2.offsetTop - scrollTop;
        // let scrollDiv3 = animateBox3.offsetTop - scrollTop;
        if (scrollDiv1 <= 500) {
          this.isUp1 = true;
          this.isDisplay1 = false;
        }
        if (scrollDiv2 <= 600) {
          this.isDisplay2 = false;
          this.isUp2 = true;
        }
        // if (scrollDiv3 <= 700) {
        //   this.isDisplay3 = false;
        //   this.isUp3 = true;
        // }
      },
      goU(url) {
        this.$router.push({name: 'startApply',params:{product:3,title:'预约演示'}});
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollFun);
    },
  }
</script>

<style scoped lang="scss">
  .s2_block2 {
    .title {
      font-family: 'pingfangBold';
      font-size: 24px;
      color: #272727;
      margin:0 0 20px;
      height: 256px;
      padding-top:69px;
      box-sizing: border-box;
    }
    .wrap{
      position:relative;
      height:921px;
      background:#F5F5F5;
    }
    .wrap_box{
      position: absolute;
      left:50%;
      margin-left:-600px;
      top:-128px;
      .solution2_topBox {
        width: 1200px;
        margin: 0 auto 30px;
        height: 580px;
        background: #FFFFFF;
        border: 1px solid #CAC8C8;
        border-radius: 3px;
        box-sizing: border-box;
        padding:20px 30px 30px;
        .s2_topBoxinfo{
          text-align: left;
          .topTitle{
            font-size: 18px;
            color:#000;
            font-family: 'pingfangBold';
            span{
              font-size: 36px;
              color: #0D72FD;
              margin-right:5px;
              position:relative;
              top:5px;
            }
          }
          .topMid{
            padding-left:50px;
            font-size: 14px;
            color: #4A4A4A;
            margin-bottom:6px;
            span{
              color: #000000;
              margin-right:8px;
            }
          }
        }
        .s2_bottomBoxinfo{
          width:1140px;
          height:390px;
          background: #67A7FF;
          border: 1px solid #D8D8D8;
          border-radius: 5px;
          box-sizing: border-box;
          margin-top:40px;
          i{
            display: inline-block;
            width:983px;
            height:350px;
            background: url("../../assets/img/solution2/solution2.png") no-repeat center;
            background-size:100% 100%;
          }
        }
      }
    }
    .w_bot{
      .mid{
        font-family: 'pingfangBold';
        margin-bottom:13px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/solution/solution2.vue